import { useEffect, useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { fetchOverdueSowings } from '@/lib/season/api';
import type { OverdueSowingItem } from '@/lib/season/types';

/**
 * Пассивный баннер на /dashboard — есть посевы в статусе 'growing'
 * без признака озимый/многолетник. Spec: §5.7.
 */
export function OverdueSowingsBanner() {
  const [items, setItems] = useState<OverdueSowingItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchOverdueSowings()
      .then((r) => {
        if (!cancelled) setItems(r);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading || items.length === 0 || dismissed) return null;

  const years = Array.from(new Set(items.map((i) => i.sowing_season_year)))
    .sort()
    .join(', ');

  return (
    // Компактный однострочный баннер (AK-298): не дублирует высоту 2FA-бара,
    // когда оба стоят стопкой. Стиль выровнен со StackedBanners (py-1.5).
    <Alert
      variant="warning"
      className="mb-4 flex items-center justify-between gap-3 py-1.5 px-4"
    >
      <div className="flex items-center gap-2 min-w-0">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <AlertDescription className="text-sm leading-tight">
          В сезонах <strong>{years}</strong> есть{' '}
          <strong>{items.length}</strong> посевов «растёт» без признака
          озимый/многолетник — пометьте культуру или зафиксируйте уборку.
        </AlertDescription>
      </div>
      <Button
        size="sm"
        variant="ghost"
        className="h-7 w-7 p-0 shrink-0"
        aria-label="Закрыть"
        onClick={() => setDismissed(true)}
      >
        <X className="h-4 w-4" />
      </Button>
    </Alert>
  );
}

export default OverdueSowingsBanner;
